import {listUser} from "../../crud/user.crud";
import {put, takeLatest} from "redux-saga/effects";
export const actionTypes = {
    USER_ADDED: "USER_ADDED",
    USER_ADDED_SUCCESS: "USER_ADDED_SUCCESS",
    USER_UPDATED: "USER_UPDATED",
    USER_UPDATED_SUCCESS: "USER_UPDATED_SUCCESS"
};

const initialAuthState = {
    listData: undefined
};

export const reducer = (state = initialAuthState, action) => {
    switch (action.type) {
        case actionTypes.USER_ADDED_SUCCESS:
            {
                const {listData} = action.payload;
                return {listData};
            }
        case actionTypes.USER_UPDATED_SUCCESS:
            {
                const {listData} = action.payload;
                return {listData};
            }
        default:
            return state;
    }
};

export const actions = {
    userAdded: ({skip, limit}) => ({
        type: actionTypes.USER_ADDED,
        payload: {
            skip,
            limit
        }
    }),
    userUpdated: ({skip, limit}) => ({
        type: actionTypes.USER_UPDATED,
        payload: {
            skip,
            limit
        }
    })
};

export function * saga() {
    yield takeLatest(actionTypes.USER_ADDED, function * userAdded(action) {
        const {skip, limit} = action.payload;
        const listData = yield listUser({skip, limit});

        yield put({type: actionTypes.USER_ADDED_SUCCESS, payload: {
                listData
            }});
    });

    yield takeLatest(actionTypes.USER_UPDATED, function * userUpdated(action) {
        const {skip, limit} = action.payload;
        const listData = yield listUser({skip, limit});

        yield put({type: actionTypes.USER_UPDATED_SUCCESS, payload: {
                listData
            }});
    });
}
